import { PDFDocument } from "pdf-lib";
import type { Editor } from "./canvas";
import type { Trace } from "../shared/schema";

/** A loose sheet exports only its own artwork; the drawing underneath is not a child. */
export async function tracingSheetPdf(editor: Editor, trace: Trace) {
  const bounds = editor.getShapePageBounds(trace);
  if (!bounds || editor.isShapeHidden(trace))
    throw new Error("Show the tracing sheet before exporting it.");
  const image = await editor.toImage([trace.id], {
    format: "png",
    background: false,
    bounds,
    padding: 0,
    scale: Math.min(2, 4096 / Math.max(bounds.w, bounds.h)),
    pixelRatio: 1,
  });
  const pdf = await PDFDocument.create();
  const landscape = bounds.w >= bounds.h;
  const size: [number, number] = landscape
    ? [1190.55, 841.89]
    : [841.89, 1190.55];
  const page = pdf.addPage(size),
    png = await pdf.embedPng(await image.blob.arrayBuffer());
  const scale = Math.min(size[0] / bounds.w, size[1] / bounds.h);
  const w = bounds.w * scale,
    h = bounds.h * scale;
  page.drawImage(png, {
    x: (size[0] - w) / 2,
    y: (size[1] - h) / 2,
    width: w,
    height: h,
  });
  return pdf.save();
}

export async function exportTracingSheet(editor: Editor, trace: Trace) {
  const bytes = await tracingSheetPdf(editor, trace);
  const url = URL.createObjectURL(
    new Blob([bytes as BlobPart], { type: "application/pdf" }),
  );
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = `${trace.props.name}-tracing-sheet.pdf`;
    a.click();
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
